export enum Origin {
  CustomerPortalCPUser = '1',
  RAMS = '2',
  CustomerQuote = '3',
  QuickBooks = '4',
  CustomerPortalCPPendingUser = '5',
  CustomerPortalCPInvitedUser = '6',
  P21 = '7',
  PartnerPortal = '8'
}
